import { observable, action, computed, toJS } from 'mobx';
import { Payment } from '@/services/types';
import { paymentApi } from '@/services';
export class PaymentDetail {
  @observable accessor paymentDetail: Payment | null = null;

  @action async getDetail(tenantId: string, paymentId: string) {
    return paymentApi
      .getPayment({ body: { tenantId, paymentId } })
      .then(res => {
        this.setPaymentDetail(res);
      });
  }

  @action
  setPaymentDetail(paymentDetail: Payment) {
    this.paymentDetail = paymentDetail;
  }

  @computed
  get paymentParams() {
    return toJS(this.paymentDetail) || {};
  }
}

export default new PaymentDetail();
